const acl = {
  // Tab labels
  tabUsers: 'Users',
  tabPermissions: 'Role Permissions',
  // Role permissions panel
  selectRoleToEdit: 'Select a role to edit permissions',
  featuresEnabled: 'features enabled',
  savePermissions: 'Save Permissions',
  rolePermissionHint: 'Configuring access permissions for {{role}}. Enable or disable features and their permission levels.',
  unsavedChanges: 'You have unsaved changes.',
  grantAll: 'Grant all permissions',
  removeAll: 'Remove all permissions',
  permissionsSaved: 'Permissions saved successfully.',
  // Permission labels
  permView: 'View',
  permCreate: 'Create',
  permEdit: 'Edit',
  permDelete: 'Delete',
  permManage: 'Manage',
  // Sidebar tooltips
  noAccess: 'No access',
};

export default acl;